export default class DtoStationType {
    constructor(object) {
        this.code = object.code
        this.name = object.name === 'HYDRO' ? 'HYDROMETRIC_STATION' : object.name
        this.i18n = object.i18n
    }
}